var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"height":_vm.height,"type":"bar","options":_vm.options,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }